var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeace = function SvgPeace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 18.2c4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8 3.59 8 8 8m.533-14.942.621.104a6.91 6.91 0 0 1 5.78 6.835 6.9 6.9 0 0 1-.974 3.536l-.343.576-5.086-4.872V3.258zm0 7.66 4.385 4.2-.453.38c-.947.8-2.091 1.331-3.31 1.537l-.62.105v-6.225zm-1.066 6.224-.621-.105a6.93 6.93 0 0 1-3.31-1.536l-.453-.381 4.385-4.2v6.224zm-6.4-6.942a6.91 6.91 0 0 1 5.779-6.834l.62-.105v6.18l-5.085 4.872-.343-.576a6.94 6.94 0 0 1-.973-3.537z"
  })));
};
export default SvgPeace;